import PenilaianKaryawan from "../../../../../components/categories/siakad/laporan_adab/penilaian_karyawan_multiple/Home";
export default function Home() {
  
  return (
    <PenilaianKaryawan />
  );
}
